function copyToClipboard(target, containerID) {

    console.log('target', target);
    console.log('containerID', containerID);

    var $copyLabel = target.querySelector('.js-copy-copy'),
        $copiedLabel = target.querySelector('.js-copy-copied'),
        range = document.createRange();

    range.selectNode(containerID);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();


    $copyLabel.classList.add('hide');
    $copiedLabel.style.display =  'block';

    setTimeout(function(){
        $copyLabel.classList.remove('hide');
        $copiedLabel.style.display = 'none';
    },5000);

    amplitude_log_event('tools_clipboard_button_clicked');
}